import React, { useEffect, useState } from "react";
import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import Faqcardsupport from "./faq_card_support";

const Faqbody = () => {
  const [activeTab, setActiveTab] = useState("general");
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const [languageData, setLanguageData] = useState(null);

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/faq/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  if (!languageData) {
    return <div></div>;
  }

  return (
    <div className="col-xxl-8 col-xl-10 col-lg-10 col-md-10 col-sm-10 col-12">
      <ul
        className="nav nav-pills nav-justified mb-3 gx-3 tab-style-6 d-sm-flex d-block"
        id="pills-tab"
        role="tablist"
      >
        <li className="nav-item rounded" role="presentation">
          <button data-interaction="general_faq_button"
            className={`nav-link d-flex align-items-center ${
              activeTab === "general" ? "active" : ""
            }`}
            type="button"
            onClick={() => handleTabClick("general")}
          >
            <i className="bx bx-layer fs-20 me-2"></i>
            <span className="d-block">{languageData.page.general}</span>
          </button>
        </li>
        <li className="nav-item rounded" role="presentation">
          <button data-interaction="support_faq_button"
            className={`nav-link d-flex align-items-center ${
              activeTab === "support" ? "active" : ""
            }`}
            type="button"
            onClick={() => handleTabClick("support")}
          >
            <i className="bx bx-support fs-20 me-2"></i>
            <span className="d-block">{languageData.page.support}</span>
          </button>
        </li>
        <li className="nav-item rounded" role="presentation">
          <button data-interaction="security_faq_button"
            className={`nav-link d-flex align-items-center ${
              activeTab === "Security" ? "active" : ""
            }`}
            type="button"
            onClick={() => handleTabClick("Security")}
          >
            <i className="bx bx-shield-plus fs-20  me-2"></i>
            <span className="d-block">{languageData.page.security}</span>
          </button>
        </li>
        <li className="nav-item rounded" role="presentation">
          <button data-interaction="services_faq_button"
            className={`nav-link d-flex align-items-center ${
              activeTab === "Services" ? "active" : ""
            }`}
            type="button"
            onClick={() => handleTabClick("Services")}
          >
            <i className="bx bx-cog fs-20  me-2"></i>
            <span className="d-block">{languageData.page.services}</span>
          </button>
        </li>
        <li className="nav-item rounded" role="presentation">
          <button data-interaction="others_faq_button"
            className={`nav-link d-flex align-items-center ${
              activeTab === "Others" ? "active" : ""
            }`}
            type="button"
            onClick={() => handleTabClick("Others")}
          >
            <i className="bx bx-category fs-20  me-2"></i>
            <span className="d-block">{languageData.page.others}</span>
          </button>
        </li>
        {/* Other tabs */}
      </ul>

      <div className="tab-content" id="pills-tabContent">
        <div
          className={`tab-pane p-0 border-0 ${activeTab === "general" ? "active show" : ""}`}
          id="pills-general"
          role="tabpanel"
        >
          <Faqcardsupport activeTab={activeTab} />
        </div>

        {activeTab === "support" && (
          <div
            className={`tab-pane p-0 border-0 ${activeTab === "support" ? "active show" : ""}`}
            id="pills-support"
            role="tabpanel"
          >
            <Faqcardsupport activeTab={activeTab} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Faqbody;
